import xs from "xstream"
import isolate from "@cycle/isolate"
import sampleCombine from "xstream/extra/sampleCombine"
import * as R from "ramda"

import {dumper} from '../../utils'
import {PAGE, STATE_KEY} from '../../constant'

import {pageViewTempl, input2Prop, isDemoUser} from '../common'

import {view} from './view'

const Policy = sources => {
	// const eventInfo$ = sources.state.select([STATE_KEY.Event])
	// const user$ = sources.state.select([STATE_KEY.User])

	const cbGranted$ = sources.DOM.select("#cbGranted").events('change').map(e => e.target.checked)

	const granted$ = cbGranted$.startWith(false).remember()

	const route$ = sources.DOM.select("#btn2CreditForm").events('click')
    .mapTo("/top")
		// .compose(sampleCombine(user$))
		// .map(([_, user]: [any, any]) => {
		// 	// console.log(user.get("id", 0), isDemoUser(user.get("id", 0)))
		// 	// if (isDemoUser(user.get("id", 0))) {
		// 	// 	return "/member/id"
		// 	// }
		// 	// return "/member/top"
		// 	return "/member/id"
		// })
		// .filter(r => r)

	const view$ = view(granted$)

	const pageView = pageViewTempl(PAGE.Policy.id)
	return {
		DOM: pageView(view$),
    // dumper: sources.state.select(),
		router: route$
	}
}
export default isolate(Policy)
